import { SCENE_SCALE } from "../../constants";

export const DistanceFromObject = 2.5 * SCENE_SCALE;